import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';
import { CaptivePortalIcon } from '@openx/components-core/icons/CaptivePortalIcon/CaptivePortalIcon.tsx';
import type { RequiredTargetingFormType } from '@openx/types/targeting/targetingPresets.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type Section, TargetingElementKeys, type TargetingElementKeysType } from '../../context/types.ts';
import { convertApiToSet } from '../../utils/convertApiToSet.ts';

export const useReadOnlyChannelInitialState = (
  targetingParams: RequiredTargetingFormType | null | undefined
): Section => {
  const { t } = useTranslation();

  return useMemo(() => {
    const formValue = targetingParams?.distribution_channel.val;
    const initValues = convertApiToSet(formValue);
    const isSelected = (key: TargetingElementKeysType): boolean => initValues.has(key);

    return {
      label: t('Channel'),
      isLoading: true,
      elements: [
        {
          mainOption: {
            key: TargetingElementKeys.CHANNEL_WEB,
            icon: <CaptivePortalIcon />,
            label: t('Web'),
            isSelected: isSelected(TargetingElementKeys.CHANNEL_WEB),
            isDisabled: true,
          },
        },
        {
          mainOption: {
            key: TargetingElementKeys.CHANNEL_APP,
            label: t('App'),
            icon: <WidgetsOutlined />,
            isSelected: isSelected(TargetingElementKeys.CHANNEL_APP),
            isDisabled: true,
          },
        },
      ],
    };
  }, [t, targetingParams]);
};
